import { Row, Col } from "antd";

import IconButton from "../iconButton";

const SubmitButton = ({
  icon,
  cols,
  text,
  start,
  title,
  center,
  loading,
  onClick,
  disabled,
  showButton = true,
}) => (
  <Row justify={center ? "center" : start ? "start" : "end"} gutter={[20, 10]}>
    {cols}
    {showButton && (
      <Col>
        <IconButton
          icon={icon}
          text={text}
          title={title}
          htmlType="submit"
          onClick={onClick}
          loading={loading}
          disabled={disabled}
        />
      </Col>
    )}
  </Row>
);

export default SubmitButton;
